<template>
    <div ref="root" class="carousel-root" :class="{ 'carousel-root-hideArrows': shouldHideArrows }">
        <div ref="wrapper" style="position: relative; height: 100%; width: 100%;">
            <div
                ref="carousel"
                :class="{
                    'carousel-grid': true,
                    'carousel-grid-sm': onlyShowSingleItem,
                    'carousel-grid-shouldCentre': shouldCentre,
                    'carousel-grid-tight-cols': tightCols,
                }"
            >
                <template v-if="items && items.length > 0">
                    <component
                        v-for="(item, index) in items"
                        :key="index"
                        :is="component"
                        class="scroll-snap-to"
                        v-bind="item"
                        @click="() => handleItemClick(item)"
                    />
                </template>
                <div v-else class="py-3 d-flex flex-column justify-content-center">
                    <div v-if="noResourcesImage">
                        <img class="no-resource-image mb-3" :src="noResourcesImage" />
                    </div>
                    {{ noResourcesMessage ? noResourcesMessage : 'No resources found' }}
                </div>
            </div>
            <IconBtn
                ref="button"
                v-if="!shouldHideArrows"
                @click="scrollLeft"
                size="lg"
                class="primary-outlined hideWhenNotHover"
                name="arrow-left"
                :style="{ top: top + 'px' }"
                style="position: absolute; left: 4px; background-color: white;"
            />
            <IconBtn
                v-if="!shouldHideArrows"
                @click="scrollRight"
                size="lg"
                class="primary-outlined hideWhenNotHover"
                name="arrow-right"
                :style="{ top: top + 'px' }"
                style="position: absolute; right: 4px; background-color: white;"
            />
        </div>
    </div>
</template>

<script>
import CarouselDefault from './Carousel.Default';
import DialogService from '~/services/DialogService';

export default {
    name: 'Carousel',
    components: { CarouselDefault },

    data() {
        return {
            top: 100,
        };
    },

    props: {
        component: {
            type: Object,
            optional: true,
            default: () => CarouselDefault,
        },
        onlyShowSingleItem: Boolean, // Stops the carousel from displaying more than one item at a time
        hideArrows: Boolean, // Removes the previous/next arrows from the carousel
        items: {
            type: Array,
            optional: true,
        },
        noResourcesImage: [Object, String],
        noResourcesMessage: String,
        tightCols: Boolean,
        dontCenter: Boolean,
    },

    computed: {
        shouldHideArrows() {
            return (
                this.hideArrows ||
                (this.items.length <= 4 && !this.onlyShowSingleItem) ||
                this.items.length <= 1
            );
        },
        shouldCentre() {
            return (
                this.shouldHideArrows &&
                !this.onlyShowSingleItem &&
                this.items.length < 4 &&
                !this.dontCenter
            );
        },

        canScrollLeft() {
            this.$refs.carousel.scrollLeft !== 0;
        },
        canScrollRight() {
            // console.log(this.$refs.carousel.scrollWidth);
            this.$refs.carousel.scrollLeft === this.$refs.carousel.scrollWidth;
        },
    },

    methods: {
        scrollLeft() {
            // The constant that is added on, should be the same value as the --grid-gap variable set in the css
            const widthToScroll = this.$refs.carousel.clientWidth + 10;
            this.$refs.carousel.scrollLeft -= widthToScroll;
        },
        scrollRight() {
            // The constant that is added on, should be the same value as the --grid-gap variable set in the css
            const widthToScroll = this.$refs.carousel.clientWidth + 10;
            this.$refs.carousel.scrollLeft += widthToScroll;
        },
        handleResizeEvent() {
            this.top = this.$refs.wrapper.clientHeight / 2 - 15;
        },
        handleItemClick(item) {
            this.$emit('item-click', item);
        },
    },

    mounted() {
        this.$nextTick(() => {
            window.addEventListener('resize', this.handleResizeEvent);
        });
        this.handleResizeEvent();
    },

    destroyed() {
        window.removeEventListener('resize', this.handleResizeEvent);
    },
};
</script>

<style lang="css" scoped>
.carousel-grid {
    --grid-gap: 10px;
    display: grid;
    min-height: 160px;
    width: 100%;
    word-break: break-word;
    grid-auto-columns: calc(25% - 3/4 * var(--grid-gap));
    /*grid-gap: var(--grid-gap);*/
    text-align: center;
    grid-auto-flow: column;
    overflow-x: auto;
    overflow-y: hidden;
    scrollbar-width: none;
    scroll-behavior: smooth;
}

.carousel-grid-tight-cols {
    grid-auto-columns: calc(12% - 3/4 * var(--grid-gap));
}

.carousel-grid-sm {
    grid-auto-columns: 100%;
    scroll-snap-type: x proximity;
    scroll-snap-type: proximity;
    scroll-snap-destination: 0 0;
    /* scroll-snap-points-x: repeat(100%); */
    scroll-snap-points-x: repeat(calc(100% + var(--grid-gap)));
}

/* .carousel-grid > * {
    padding-bottom: 20px;
} */

.carousel-grid-shouldCentre {
    justify-content: center;
    grid-auto-columns: 0.5fr;
}

.scroll-snap-to {
    scroll-snap-align: end;
    scroll-snap-stop: normal;
}

.hideWhenNotHover {
    opacity: 0;
    transition: opacity .5s ease-in-out;
}

.carousel-root:hover .hideWhenNotHover {
    opacity: 1;
}

.no-resource-image {
    max-width: 140px;
    max-height: 100px;
    width: 100%;
    object-fit: scale-down;
    color: var(--primary);
}

@media only screen and (max-width: 500px) {
    .hideWhenNotHover {
        opacity: 1;
    }
    .carousel-grid {
        grid-auto-columns: 100%;
        scroll-snap-type: x proximity;
        scroll-snap-type: proximity;
        scroll-snap-destination: 0 0;
        /* scroll-snap-points-x: repeat(100%); */
        scroll-snap-points-x: repeat(calc(100% + var(--grid-gap)));
    }
    .carousel-grid-shouldCentre {
        justify-content: start;
    }
}
</style>
